import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import { Single } from "../sites/";
import { Lead } from "@cs125/gatsby-theme-cs125/src/material-ui";
import { LoremIpsum } from "@cs125/gatsby-theme-cs125/src/lorem-ipsum";
import Flasher from "../components/Flasher";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component '" + name + "' was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = Single;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">




    <p><a parentName="p" {...{
        "href": "https://www.npmjs.com/package/@cs125/element-tracker"
      }}><img parentName="a" {...{
          "src": "https://img.shields.io/npm/v/@cs125/element-tracker",
          "alt": "npm"
        }}></img></a>{`
`}<img parentName="p" {...{
        "src": "https://img.shields.io/docker/v/cs125/element-tracker?color=green&label=Docker&sort=date",
        "alt": "Docker Image Version (latest by date)"
      }}></img>{`
`}<a parentName="p" {...{
        "href": "https://opensource.org/licenses/MIT"
      }}><img parentName="a" {...{
          "src": "https://img.shields.io/badge/License-MIT-yellow.svg",
          "alt": "License: MIT"
        }}></img></a></p>
    <pre><code parentName="pre" {...{
        "className": "language-sh",
        "metastring": "id=install",
        "id": "install"
      }}>{`npm i @cs125/element-tracker # client
docker pull cs125/element-tracker # server
`}</code></pre>
    <Lead mdxType="Lead"></Lead>
    <h2>{`Use`}</h2>
    <p>{`Visit the `}<a parentName="p" {...{
        "href": "https://github.com/cs125-illinois/element-tracker"
      }}>{`documentation here`}</a>{`.`}</p>
    <h2>{`Demo`}</h2>
    <p>{`Some dummy content follows to make the page long enough for the sidebar navigation to kick in.
First, a flasher to test our mutation listener.`}</p>
    <Flasher mdxType="Flasher" />
    <h2>{`First`}</h2>
    <LoremIpsum p={2} mdxType="LoremIpsum" />
    <h3>{`First First`}</h3>
    <LoremIpsum p={1} mdxType="LoremIpsum" />
    <h3>{`First Second`}</h3>
    <LoremIpsum p={3} mdxType="LoremIpsum" />
    <h4>{`First Second First`}</h4>
    <LoremIpsum p={3} mdxType="LoremIpsum" />
    <h2>{`Second`}</h2>
    <LoremIpsum p={4} mdxType="LoremIpsum" />
    <h3>{`Second First`}</h3>
    <LoremIpsum p={1} mdxType="LoremIpsum" />
    <h4>{`Second First First`}</h4>
    <LoremIpsum p={1} mdxType="LoremIpsum" />
    <h2>{`Last`}</h2>
    <LoremIpsum p={1} mdxType="LoremIpsum" />

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      